import * as Yup from "yup";

const validationSchema = Yup.object().shape({
  groupName: Yup.string().max(50).required("Enter group name."),
  groupStatus: Yup.string().required("Select group status "),
});

export default validationSchema;
